import React from "react";
const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="rvc">
        <p className="grt"></p>
      </div>
      <div className="rvc">
        <p className="wel">MY NAME IS</p>
      </div>
      <div className="rvc">
        <h1 className="nam">Saurabh Verma.</h1>
      </div>
      <div className="rvc">
        <h1 className="pass">
          I'm a <span className="fs">full stack developer.</span>
        </h1>
      </div>
      <div className="rvc">
        <h1 className="pass">I build things for the web and mobile devices.</h1>
      </div>
      <div className="rvc">
        <p className="msg">
          I’m a MERN stack developer, curious to decode the tech behind the best
          digital experiences around the globe. Currently I'm focused on
          bringing the immersive 3D expirience to my upcoming projects.
        </p>
      </div>
    </section>
  );
};

export default Hero;
